@if (hasSuggestions()) {
  <div class="mt-2">
    <div class="font-weight-bold small mb-1 mt-2 px-2">{{ "aiReport.lbl_suggestions" | translate }}:</div>
    <div class="ai-suggest border rounded-lg p-2 overflow-auto pr-1">
      @for (s of suggestions(); track s) {
        <button type="button" class="chat-suggestion btn btn-outline-secondary btn-block text-left py-2 mb-2"
                (click)="selectSuggestion(s)"
                [title]="s">
          <span class="small d-block text-truncate">{{ s }}</span>
        </button>
      }
    </div>
  </div>
}
